export default __webpack_public_path__ + "static/media/girl.93b0d565.png";